import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/users' }),
  endpoints: (builder) => ({
    getCurrentUser: builder.query({
      query: () => ({ url: 'current' }),
      providesTags: ['User']
    }),
    getUsers: builder.query({
      query: (searchParams = '') => ({ url: searchParams }),
      providesTags: ['Users']
    }),
    getUser: builder.query({
      query: (id) => `/${id}`
    }),
    updateUser: builder.mutation({
      query: ({ id = '', ...data }) => ({
        url: `${id}`,
        method: 'PATCH',
        body: { user: data }
      }),

      invalidatesTags: ['Users']
    }),
    createUser: builder.mutation({
      query: (body) => ({
        method: 'POST',
        body: { user: body }
      }),
      invalidatesTags: ['Users']
    })
  })
})

export const { useGetUsersQuery, useGetUserQuery, useUpdateUserMutation, useCreateUserMutation, useGetCurrentUserQuery } = userApi
export { userApi }
